module.exports = __webpack_public_path__ + "img/dropdown_selected.3935ead3.svg";